var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damage", class: { "damage--options": _vm.options } },
    [
      _c("div", { staticClass: "damage__container" }, [
        _c("h3", { staticClass: "damage__title" }, [
          _vm._v(_vm._s(_vm.damage.literal)),
        ]),
        _vm.damage.description
          ? _c("p", { staticClass: "damage__description" }, [
              _vm._v(_vm._s(_vm.damage.description)),
            ])
          : _vm._e(),
        _vm.options
          ? _c(
              "div",
              { staticClass: "damage__options" },
              [
                _c("svgicon", {
                  staticClass: "damage-option",
                  attrs: {
                    name: "ico-pencil-create",
                    color: "#566473",
                    height: "20",
                    width: "auto",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("option:edit")
                    },
                  },
                }),
                _c("svgicon", {
                  staticClass: "damage-option",
                  attrs: {
                    name: "ico-trash",
                    color: "#566473",
                    height: "20",
                    width: "auto",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("option:delete")
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }